<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <div class="custom-toolbar">
                <div class="custom-toolbar-start">
                    <router-link
                        :to="{
                            name: 'Billing Profile'
                        }"
                    >
                        <h3 class="title">Billing</h3>
                    </router-link>
                    <h3 class="title">&nbsp;&nbsp; > &nbsp;&nbsp; {{ $t('menus.billing.profile') }}</h3>
                </div>
            </div>
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>payment</md-icon>
                    </div>
                </md-card-header>

                <md-card-content>
                    <div class="cf-container">
                        <h4>
                            Manage your Locate2u Subscription
                        </h4>
                        <p>
                            {{ subTitleMessageEnt }}
                            <MailToSupport />
                            {{ subTitleMessageEntPart2 }}
                        </p>
                    </div>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { showErrorMessage } from '@/helpers';
import { mapActions, mapGetters } from 'vuex';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { MailToSupport } from '@/components';

export default {
    name: 'BillingProfile',
    components: { MailToSupport },
    mixins: [GeneralMixin],
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            hasTeam: 'user/hasTeam',
            user: 'user/user',
            teamStatus: 'team/teamStatus'
        }),
        license() {
            return this.user.license ?? {};
        },
        trialDaysLeft() {
            const trialEnd = this.license.trialEnd || moment();
            const today = moment().startOf('day');
            const expiryDate = moment(trialEnd);
            return expiryDate.diff(today, 'days');
        },
        subTitleMessageEnt() {
            let msg = 'Please ';

            if (this.license && this.license.status === 'Disabled') {
                msg = `It looks like there was an issue with your payment, and your account has been temporarily paused. To continue enjoying Locate2u, please update your payment details. `;
                msg += `If you need any help, `;
            } else if (this.license?.status === 'Trial' && this.trialDaysLeft <= 0) {
                msg = `Your trial has ended. To keep using Locate2u, `;
            }

            return msg;
        },
        subTitleMessageEntPart2() {
            let msg = ' to upgrade your account.';
            if (this.license && this.license.status === 'Disabled') {
                msg = `.`;
            } else if (this.license?.status === 'Trial' && this.trialDaysLeft <= 0) {
                return ` to upgrade. We're here to help!`;
            }

            return msg;
        }
    },
    methods: {
        ...mapActions('user', ['FETCH_LICENSE']),
        async getLicense() {
            this.$_handleLoaderState(true, 'Fetching license details');
            try {
                await this.FETCH_LICENSE();
            } catch (e) {
                const message = 'Unable to retrieve license details.';
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        },
        getStatusCssClass(status) {
            switch (status) {
                case 'Disabled':
                    return 'license-status-disabled';
                default:
                    return 'license-status-active';
            }
        }
    },
    async mounted() {
        await this.getLicense();
    }
};
</script>

<style lang="scss" scoped>
.title {
    display: inline-block;
}

.card-icon {
    background: #7069fe !important;
}

.stripe-button {
    display: inline;
    position: center;
}
.no-stripe-text {
    color: Red !important;
}

.subscription-open {
    border-bottom: 1px solid #eee;
}

.subscription-list-body {
    margin: 0 0 10px 0;
    border-radius: 0;
    padding: 0;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

    ::v-deep .md-list-item {
        margin-left: 0;
    }

    ::v-deep .md-list-item .md-list-item-container {
        font-weight: 100;

        a {
            font-weight: 100;
        }
    }

    ::v-deep .md-list-item .md-list-item-container .md-ripple {
        padding: 0;
        border-radius: 0;

        .md-list-expand-icon {
            margin-left: 0;
            margin-right: 10px;
            z-index: 1;
            position: absolute;
            right: 0;
        }
    }

    ::v-deep .md-list-item .md-list-item-container .md-ripple:hover {
        background-color: #fff !important;
    }

    ::v-deep .md-list-item .md-list-item-container .alert-section .md-ripple:hover {
        background-color: initial !important;
    }

    ::v-deep .md-list-item .md-list-item-container .stop-actions .md-ripple:hover {
        background-color: initial !important;
    }

    ::v-deep .md-card-actions {
        button {
            height: 30px;
            min-width: 30px;
            width: 30px;
        }
    }

    ::v-deep .md-card-expand-content {
        border-top: 1px solid #eee;
    }

    .subscription-items-table-body {
        padding: 10px 20px;
        max-height: 500px;
        overflow: auto;
    }

    .empty-table {
        height: 150px;
        display: block;
    }
}

.subscription-list-body:first-child {
    margin-top: 40px;
}

.subscription-accordion-header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 55px;
    position: relative;
    padding-right: 30px;
    z-index: 10;
    .subscription-name {
        font-size: 14px;
        width: 40%;
        text-transform: uppercase;
        font-weight: 600;
        a {
            color: rgba(0, 0, 0, 0.87);
        }
        .custom-ellipsis {
            max-width: 60%;

            .display-sub-name {
                font-weight: normal;
                color: #666;
                margin: 0;
            }
        }
        span {
            margin-left: 15px;
        }
    }
    .subscription-details {
        width: 60%;
        font-size: 1rem;
        display: flex;
        align-items: center;
        align-content: space-between;
        justify-content: space-between;

        span {
            text-transform: uppercase;
            font-weight: 400;
            margin-right: 5px;
            cursor: pointer;
        }
    }
}

.md-tooltip {
    min-width: 300px !important;
}

.ddl-customers {
    .md-list-item md-menu-item {
        margin: 10px;
    }
}

::v-deep .md-list-item {
    padding: 10px !important;
    background-color: yellow !important;
    height: 80px !important;
}

.row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
}

.column {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
    margin: 5px;
    padding: 5px;
}

::v-deep .license-label {
    display: inline !important;
}

::v-deep .license-status {
    display: inline !important;
}

.license-status-disabled {
    color: slategray !important;
    font-weight: bold;
}

.license-status-active {
    color: green !important;
    font-weight: bold;
}
</style>
